module.exports = __webpack_public_path__ + "img/golog_admin2.bea8bb80.png";